import React from 'react';
import axios from 'axios';
import { Modal, Button } from 'react-bootstrap';
import authHeader from '../services/AuthHeader';
import ViewStatement from './ViewStatement';

function ReviewCandidateModal({
  show,
  onHide,
  user = {},
  setRerender = () => {},
  ...modalProps
}) {
  // Double-check your .env variable:
  if (!process.env.REACT_APP_API_BASE) {
    console.error('REACT_APP_API_BASE is not defined in your environment!');
  }

  const candidate = {
    BallotCandidateId: user.ballotCandidateId,
    StarId: user.starId,
    CandidateEmail: user.candidateEmail,
    CandidateStatement: user.candidateStatement,
    CandidateStatus: ''
  };

  const approveHandler = (e) => {
    e.preventDefault();
    candidate.CandidateStatus = 'r';
    axios
      .put(
        process.env.REACT_APP_API_BASE + 'candidate/' + user.candidateId,
        candidate,
        { headers: authHeader() }
      )
      .then(() => setRerender(true))
      .catch((err) => console.error(err));
    onHide();
  };

  const declineHandler = (e) => {
    e.preventDefault();
    candidate.CandidateStatus = 'x';
    axios
      .put(
        process.env.REACT_APP_API_BASE + 'candidate/' + user.candidateId,
        candidate,
        { headers: authHeader() }
      )
      .then(() => setRerender(true))
      .catch((err) => console.error(err));
    onHide();
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size='lg'
      centered       // Use the boolean prop (NOT centered="true")
      {...modalProps}
    >
      <Modal.Header closeButton>
        <Modal.Title>Review This Candidate</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ViewStatement StarId={user.starId} />
        <div style={{ marginTop: 20 }} className='modal-button-row'>
          <div className='modal-button-column'>
            {user.candidateStatus !== 'r' && (
              <Button
                className='btn btn-success'
                type='button'
                onClick={approveHandler}
              >
                Approve
              </Button>
            )}
          </div>
          <div className='modal-button-column'>
            {user.candidateStatus !== 'x' && (
              <Button
                className='btn btn-danger'
                style={{ float: 'right' }}
                type='button'
                onClick={declineHandler}
              >
                Decline
              </Button>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ReviewCandidateModal;
